<script setup>
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const dialogRef = ref(null);
const contactName = ref('');
let resolvePromise = null;

const open = (phoneNumber = '') => {
  contactName.value = '';
  return new Promise(resolve => {
    resolvePromise = resolve;
    dialogRef.value?.open();
  });
};

const handleConfirm = () => {
  const name = contactName.value.trim();
  if (resolvePromise) {
    resolvePromise(name || null);
    resolvePromise = null;
  }
  dialogRef.value?.close();
};

const handleClose = () => {
  if (resolvePromise) {
    resolvePromise(null);
    resolvePromise = null;
  }
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    type="edit"
    :title="$t('FILTER.ATTRIBUTES.UNREAD_COUNT') ? 'שם איש קשר' : 'Contact Name'"
    confirm-button-label="Save"
    cancel-button-label="Cancel"
    :disable-confirm-button="!contactName.trim()"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <Input
      v-model="contactName"
      placeholder="Enter contact name..."
      autofocus
      @enter="handleConfirm"
    />
  </Dialog>
</template>
